import React, { useEffect } from 'react';

export default function CategoryFilterMenu({ isOpen, categories, activeCategory, onSelect, onClose }) {
  useEffect(() => {
    if (!isOpen) return;

    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <>
      <div
        className={`category-menu-backdrop ${isOpen ? 'open' : ''}`}
        onClick={onClose}
        data-testid="category-menu-backdrop"
      />
      <div
        className={`category-menu-panel ${isOpen ? 'open' : ''}`}
        data-testid="category-menu-panel"
      >
        <div className="category-menu-header">
          <h3 className="category-menu-title">Categories</h3>
        </div>

        <button
          className={`category-menu-item ${activeCategory === null ? 'active' : ''}`}
          onClick={() => onSelect(null)}
        >
          All Photos
        </button>

        {categories.map(category => (
          <button
            key={category.id}
            className={`category-menu-item ${activeCategory?.id === category.id ? 'active' : ''}`}
            onClick={() => onSelect(category)}
          >
            {category.name}
          </button>
        ))}
      </div>
    </>
  );
}
